/**
 * @deprecated
 * Created by yangxx on 2016/12/12.
 * 不带ui的组件基类
 */
'use strict';
define([
    './ComponentBase'
], function (ComponentBase) {
    /**
     * 组件初始化构造方法
     * @ignore
     * @constructor
     * @classdesc 不带ui的组件基类
     * @alias G.base.PureComponent
     * @augments G.base.ComponentBase
     * @param {Object} options - 必填，构造参数对象
     * @returns {Class} 实例化对象
     */
    var component = ComponentBase.extend({
        //默认配置项
        options: {
            //地图对象
            map: null
        },

    initialize:function (options) {
        ComponentBase.prototype.initialize.call(this, options);
        //
    }
    ,
    /**
     * 销毁，对应initialize
     * @method
     * @memberOf G.base.PureComponent.prototype
     */
    destroy:function () {
        //
        ComponentBase.prototype.destroy.call(this);
    }
})
    ;
    return component;
})